import { persistentAtom } from '@nanostores/persistent'

export const registryData = persistentAtom(
    'registry',
    {},
    {
        encode(registryObj) {
            return JSON.stringify(registryObj)
        },
        decode(registryObj) {
            return JSON.parse(registryObj)
        },
    }
)
